import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import PrivacyPolicy from './components/Privacy';
import Terms from './components/Terms';
import AffiliateDisclosure from './components/AffiliateDisclosure';
import AmazonAgreement from './components/AmazonAgreement';
import Footer from './components/Footer';

const App = () => {
  return (
    <Router>
      <Header />
      <div className="main-content">
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route path="/about" element={<About/>} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/privacy" element={<PrivacyPolicy/>} />
          <Route path="/terms" element={<Terms/>} />
          <Route path="/affiliate-disclosure" element={<AffiliateDisclosure/>} />
          <Route path="/amazon-affiliate-agreement" element={<AmazonAgreement/>} />
        </Routes>
      </div>
      <Footer/>
    </Router>
  );
};

export default App;
